import { useNavigate } from 'react-router-dom';
import { Button } from '../../../button/Button';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { DestinationTrackers } from '../../tracking/destination-trackers';
import { Tooltip } from '../../../tooltip/Tooltip';

interface CreateDestinationButtonProps {
  // eslint-disable-next-line react/no-unused-prop-types
  isV1?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

export function CreateDestinationButton({
  disabled = false,
  disabledReason = ''
}: CreateDestinationButtonProps) {
  const navigate = useNavigate();
  const { eventTrack } = useAnalyticsTracker();

  const onAddDestinationClick = () => {
    eventTrack({
      action: DestinationTrackers.DESTINATION_TRACKER_DESTINATION_LIST_ADD_DESTINATION_CLICK
    });
    navigate(`/destination/edge/create`);
  };

  return (
    <Tooltip dataId='' title={disabledReason} disabled={!disabled}>
      <Button
        dataId='create-destination'
        size='md'
        icon='plus'
        className='ml-5'
        onClick={onAddDestinationClick}
        disabled={disabled}
      >
        Create Edge Destination
      </Button>
    </Tooltip>
  );
}
